import { render, staticRenderFns } from "./CheckoutView.vue?vue&type=template&id=3e85e719"
import script from "./CheckoutView.vue?vue&type=script&lang=js"
export * from "./CheckoutView.vue?vue&type=script&lang=js"
import style0 from "./CheckoutView.vue?vue&type=style&index=0&id=3e85e719&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports